import React, {
  useEffect,
  useState,
} from "react";


const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
export default function LampokameraKorttiBlock({
  data = {},
  onChange,
  onAddRoom,
  kiinteisto,
}) {

  // -------------------------------------------------------
  // LOCAL FORM STATE
  // -------------------------------------------------------

  const [form, setForm] =
    useState(() => ({
      room:
        data.room ?? "",

      correctedTemperatureIndex:
        data.correctedTemperatureIndex ??
        "",

      temperatureIndex:
        data.temperatureIndex ??
        "",

      minAreaTemperature:
        data.minAreaTemperature ??
        "",

      pointTemperature:
        data.pointTemperature ??
        "",

      pressureDifference:
        data.pressureDifference ??
        "",

      indoorTemperature:
        data.indoorTemperature ??
        "",

      emissivity:
        data.emissivity ??
        "0,95",

      reflectedTemperature:
        data.reflectedTemperature ??
        "",

      distance:
        data.distance ??
        "",

      comments:
        data.comments ??
        "",

      weather:
        data.weather ??
        {},
    }));

const [thermalFile, setThermalFile] = useState(null);
const [thermalPreview, setThermalPreview] = useState(null);
const [thermalLoading, setThermalLoading] = useState(false);
const [thermalError, setThermalError] = useState("");
  // -------------------------------------------------------
  // ADD ROOM MODAL
  // -------------------------------------------------------

  const [
    showAddRoom,
    setShowAddRoom,
  ] = useState(false);


  const [
    newRoomName,
    setNewRoomName,
  ] = useState("");


  // -------------------------------------------------------
  // SYNC EXTERNAL DATA
  // -------------------------------------------------------

  useEffect(() => {

    setForm({
      room:
        data.room ?? "",

      correctedTemperatureIndex:
        data.correctedTemperatureIndex ??
        "",

      temperatureIndex:
        data.temperatureIndex ??
        "",

      minAreaTemperature:
        data.minAreaTemperature ??
        "",

      pointTemperature:
        data.pointTemperature ??
        "",

      pressureDifference:
        data.pressureDifference ??
        "",

      indoorTemperature:
        data.indoorTemperature ??
        "",

      emissivity:
        data.emissivity ??
        "0,95",

      reflectedTemperature:
        data.reflectedTemperature ??
        "",

      distance:
        data.distance ??
        "",

      comments:
        data.comments ??
        "",

      weather:
        data.weather ??
        {},
    });

  }, [data]);


  // -------------------------------------------------------
  // LOCAL EDITING
  // -------------------------------------------------------

  const updateLocal = (
    field,
    value
  ) => {

    setForm(
      (prev) => ({
        ...prev,

        [field]:
          value,
      })
    );

  };


  // -------------------------------------------------------
  // SAVE
  // -------------------------------------------------------

  const save = () => {

    onChange?.({
      ...data,
      ...form,
    });

  };


  // -------------------------------------------------------
  // WEATHER SAVE
  // -------------------------------------------------------

  const handleWeatherChange = (
    weather
  ) => {

    const next = {
      ...form,
      weather,
    };


    setForm(
      next
    );


    onChange?.({
      ...data,
      ...next,
    });

  };


  // -------------------------------------------------------
  // ADD ANOTHER ROOM
  // -------------------------------------------------------

  const handleOpenAddRoom = () => {

    setNewRoomName(
      ""
    );

    setShowAddRoom(
      true
    );

  };


  const handleCloseAddRoom = () => {

    setNewRoomName(
      ""
    );

    setShowAddRoom(
      false
    );

  };


  const handleCreateRoom = () => {

    const roomName =
      newRoomName.trim();


    if (!roomName) {

      window.alert(
        "Anna huoneelle nimi."
      );

      return;

    }


    /*
     * Save current card before
     * creating the new sibling.
     */
    onChange?.({
      ...data,
      ...form,
    });


    /*
     * Renderer inserts another
     * LampokameraKorttiBlock under
     * the SAME apartment subsection.
     */
    onAddRoom?.(
      roomName
    );


    setNewRoomName(
      ""
    );

    setShowAddRoom(
      false
    );

  };

const handleThermalImage = async (file) => {
  if (!file) return;

  setThermalLoading(true);
  setThermalError("");

  try {
    const formData = new FormData();
    formData.append("image", file);
const response = await fetch(
  `${API_URL}/api/thermal-images/analyze`,
  {
    method: "POST",
    body: formData,
    credentials: "include",
  }
);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result?.error || "Lämpökuvan analysointi epäonnistui"
      );
    }

    // Not a radiometric FLIR image
    if (!result.isThermal) {
      throw new Error(
        "Valittu kuva ei ole radiometrinen FLIR-lämpökuva."
      );
    }

    console.log("🔥 Thermal analysis:", result);

    // Show selected JPG in the card
    const previewUrl = URL.createObjectURL(file);

    setThermalFile(file);
    setThermalPreview(previewUrl);

    // Fill fields automatically from FLIR data
    const next = {
      ...form,

      minAreaTemperature:
  result.measurements?.minimum?.temperature != null
    ? Number(result.measurements.minimum.temperature)
        .toFixed(1)
        .replace(".", ",")
    : form.minAreaTemperature,
    indoorTemperature:
  result.measurementParameters?.atmosphericTemperature != null
    ? Number(result.measurementParameters.atmosphericTemperature)
        .toFixed(1)
        .replace(".", ",")
    : form.indoorTemperature,
  emissivity:
  result.measurementParameters?.emissivity != null
    ? Number(result.measurementParameters.emissivity)
        .toFixed(2)
        .replace(".", ",")
    : form.emissivity,

reflectedTemperature:
  result.measurementParameters?.reflectedTemperature != null
    ? Number(result.measurementParameters.reflectedTemperature)
        .toFixed(1)
        .replace(".", ",")
    : form.reflectedTemperature,

distance:
  result.measurementParameters?.distance != null
    ? Number(result.measurementParameters.distance)
        .toFixed(1)
        .replace(".", ",")
    : form.distance,

pointTemperature:
  result.measurements?.spot1?.temperature != null
    ? Number(result.measurements.spot1.temperature)
        .toFixed(1)
        .replace(".", ",")
    : form.pointTemperature,
    };

    setForm(next);

    onChange?.({
      ...data,
      ...next,
    });

  } catch (error) {
    console.error(error);

    setThermalError(
      error.message || "Lämpökuvan analysointi epäonnistui."
    );

  } finally {
    setThermalLoading(false);
  }
};
  // -------------------------------------------------------
  // INPUT
  // -------------------------------------------------------

  const renderInput = (
    label,
    field,
    unit = ""
  ) => (

    <div className="mb-2">

      <label className="form-label mb-1">
        {label}
      </label>


      <div className="input-group input-group-sm">

        <input
          type="text"

          className="form-control"

          value={
            form[field] ??
            ""
          }

          onChange={(e) =>
            updateLocal(
              field,
              e.target.value
            )
          }

          onBlur={
            save
          }
        />


        {unit && (

          <span className="input-group-text">
            {unit}
          </span>

        )}

      </div>

    </div>

  );


  // -------------------------------------------------------
  // RENDER
  // -------------------------------------------------------

  return (

    <div
      className="border rounded p-3 mb-3 bg-white"

      style={{
        maxWidth:
          1000,
      }}
    >


      {/* =================================================
          HEADER
      ================================================= */}

      <div className="d-flex justify-content-between align-items-start gap-3 mb-4">

        <div className="flex-grow-1">

          <label className="form-label fw-semibold">
            Huone
          </label>


          <input
            type="text"

            className="form-control"

            placeholder="Esim. Olohuone"

            value={
              form.room
            }

            onChange={(e) =>
              updateLocal(
                "room",
                e.target.value
              )
            }

            onBlur={
              save
            }
          />

        </div>


        {/* ADD ROOM */}

        {onAddRoom && (

          <div
            style={{
              paddingTop:
                "31px",
            }}
          >

       

          </div>

        )}

      </div>


      {/* =================================================
          IMAGES
      ================================================= */}

      <div className="row g-3 mb-4">


        {/* THERMAL IMAGE */}

       {/* THERMAL IMAGE */}

<div className="col-md-6">

  <label
    className="form-label fw-semibold"
    style={{ color: "#04aa00" }}
  >
    Lämpökuva
  </label>

  <label
    className="border rounded d-flex align-items-center justify-content-center position-relative overflow-hidden"
    style={{
      minHeight: 220,
      background: "#f8f9fa",
      cursor: thermalLoading ? "wait" : "pointer",
    }}
  >

    {thermalPreview ? (
      <img
        src={thermalPreview}
        alt="Lämpökuva"
        style={{
          width: "100%",
          height: 220,
          objectFit: "contain",
        }}
      />
    ) : thermalLoading ? (
      <div className="text-center">
        <div
          className="spinner-border text-success mb-2"
          role="status"
        />

        <div>
          Analysoidaan lämpökuvaa...
        </div>
      </div>
    ) : (
      <div className="text-center text-muted">
        <i
          className="bi bi-thermometer-half d-block mb-2"
          style={{
            fontSize: "2rem",
            color: "#04aa00",
          }}
        />

        <div className="fw-semibold">
          Valitse lämpökuva
        </div>

        <small>
          FLIR radiometrinen JPG
        </small>
      </div>
    )}

    <input
      type="file"
      accept=".jpg,.jpeg,image/jpeg"
      style={{
        display: "none",
      }}
      onChange={(e) => {
        const file = e.target.files?.[0];

        if (file) {
          handleThermalImage(file);
        }

        e.target.value = "";
      }}
    />

  </label>

  {thermalFile && (
    <div className="small text-muted mt-1">
      <i className="bi bi-check-circle-fill text-success me-1" />

      {thermalFile.name}
    </div>
  )}

  {thermalError && (
    <div className="alert alert-danger py-2 mt-2 mb-0">
      {thermalError}
    </div>
  )}

</div>


        {/* NORMAL IMAGE */}

        <div className="col-md-6">

          <div
            className="
              border
              rounded
              d-flex
              align-items-center
              justify-content-center
              text-muted
            "

            style={{
              minHeight:
                220,

              background:
                "#f8f9fa",
            }}
          >

            Tavallinen kuva

          </div>

        </div>

      </div>


      {/* =================================================
          MEASUREMENT DATA
      ================================================= */}

      <div className="row g-4">


        {/* LEFT COLUMN */}

        <div className="col-md-6">


          {/* TEMPERATURE INDEX */}

          <h6
            className="
              fw-bold
              border-bottom
              pb-1
            "

            style={{
              color:
                "#04aa00",
            }}
          >

            Lämpöindeksi

          </h6>


          {renderInput(
            "Paine-erokorjattu lämpöindeksi",
            "correctedTemperatureIndex"
          )}


          {renderInput(
            "Lämpöindeksi",
            "temperatureIndex"
          )}


          {/* MEASUREMENTS */}

          <h6
            className="
              fw-bold
              border-bottom
              pb-1
              mt-4
            "

            style={{
              color:
                "#04aa00",
            }}
          >

            Mittaukset

          </h6>


          {renderInput(
            "Alue minimilämpötila (Bx1)",
            "minAreaTemperature",
            "°C"
          )}


          {renderInput(
            "Pisteen lämpötila (Sp1)",
            "pointTemperature",
            "°C"
          )}


          {renderInput(
            "Paine-ero",
            "pressureDifference",
            "Pa"
          )}


          {renderInput(
            "Sisäilman lämpötila",
            "indoorTemperature",
            "°C"
          )}

        </div>


        {/* RIGHT COLUMN */}

        <div className="col-md-6">


          {/* MEASUREMENT PARAMETERS */}

          <h6
            className="
              fw-bold
              border-bottom
              pb-1
            "

            style={{
              color:
                "#04aa00",
            }}
          >

            Mittausparametrit

          </h6>


          {renderInput(
            "Emissiivisyys",
            "emissivity"
          )}


          {renderInput(
            "Heijastunut lämpötila",
            "reflectedTemperature",
            "°C"
          )}


          {renderInput(
            "Etäisyys",
            "distance",
            "m"
          )}

        </div>

      </div>


      {/* =================================================
          FMI WEATHER
      ================================================= */}

      

      {/* =================================================
          COMMENTS
      ================================================= */}

      <div className="mt-4 pt-3 border-top">

        <label className="form-label fw-bold">
          Kommentit
        </label>


        <textarea
          className="form-control"

          rows={
            3
          }

          placeholder="Kirjoita havainnot..."

          value={
            form.comments
          }

          onChange={(e) =>
            updateLocal(
              "comments",
              e.target.value
            )
          }

          onBlur={
            save
          }
        />

      </div>


      {/* =================================================
          ADD ROOM BUTTON AT BOTTOM TOO
      ================================================= */}

      {onAddRoom && (

        <div className="d-flex justify-content-end mt-3 pt-3 border-top">

          <button
            type="button"

            className="btn btn-outline-success"

            onClick={
              handleOpenAddRoom
            }
          >

            <i className="bi bi-plus-lg me-2" />

            Lisää huone

          </button>

        </div>

      )}


      {/* =================================================
          ADD ROOM MODAL
      ================================================= */}

      {showAddRoom && (

        <div
          style={{
            position:
              "fixed",

            inset:
              0,

            background:
              "rgba(0, 0, 0, 0.45)",

            zIndex:
              10000,

            display:
              "flex",

            alignItems:
              "center",

            justifyContent:
              "center",

            padding:
              "20px",
          }}

          onMouseDown={(e) => {

            if (
              e.target ===
              e.currentTarget
            ) {

              handleCloseAddRoom();

            }

          }}
        >

          <div
            className="bg-white rounded shadow"

            style={{
              width:
                "100%",

              maxWidth:
                "450px",
            }}
          >


            {/* MODAL HEADER */}

            <div className="d-flex justify-content-between align-items-center border-bottom p-3">

              <div>

                <h5 className="mb-0">
                  Lisää huone
                </h5>


                {data.huoneisto && (

                  <small className="text-muted">
                    Huoneisto{" "}
                    {data.huoneisto}
                  </small>

                )}

              </div>


              <button
                type="button"

                className="btn-close"

                onClick={
                  handleCloseAddRoom
                }
              />

            </div>


            {/* MODAL BODY */}

            <div className="p-3">

              <label className="form-label fw-semibold">
                Huoneen nimi
              </label>


              <input
                type="text"

                className="form-control"

                autoFocus

                placeholder="Esim. Makuuhuone"

                value={
                  newRoomName
                }

                onChange={(e) =>
                  setNewRoomName(
                    e.target.value
                  )
                }

                onKeyDown={(e) => {

                  if (
                    e.key ===
                    "Enter"
                  ) {

                    e.preventDefault();

                    handleCreateRoom();

                  }


                  if (
                    e.key ===
                    "Escape"
                  ) {

                    handleCloseAddRoom();

                  }

                }}
              />

            </div>


            {/* MODAL FOOTER */}

            <div className="d-flex justify-content-end gap-2 border-top p-3">

              <button
                type="button"

                className="btn btn-secondary"

                onClick={
                  handleCloseAddRoom
                }
              >

                Peruuta

              </button>


              <button
                type="button"

                className="btn btn-success"

                onClick={
                  handleCreateRoom
                }
              >

                <i className="bi bi-plus-lg me-2" />

                Lisää huone

              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}